import StyleDemo from './StyleDemo'

export default StyleDemo
// eslint-disable-next-line import/export
export * from './StyleDemo'
